import AssistantPanelLayout from "./Layout";
import AssistantPanelContent from "./Content";

const AssistantPanel = () => {
  return (
    <AssistantPanelLayout>
      <AssistantPanelContent />
    </AssistantPanelLayout>
  );
};

export default AssistantPanel;
